export const log = (data: any) => {
  if(process.env.NODE_ENV == 'development') {
    console.log(data)
  }
}

export const dir = (data: any) => {
  if(process.env.NODE_ENV == 'development') {
    console.dir(data)
  }
}

export const error = (data: any) => {
  if(process.env.NODE_ENV == 'development') {
    console.error(data)
  }
}

export const trace = () => {
  if(process.env.NODE_ENV == 'development') {
    console.trace()
  }
}

export const devconsole = {
  log,
  dir,
  error,
  trace,
}

export default devconsole